import {PageHeader} from "@ant-design/pro-layout";
import {navigateBackHandler} from "../../helpers/mainHelpers";
import React from "react";
import AdministrationList from "./components/administration-list/AdministrationList";
import EmployeeDetailModal from "./components/detail-modal/DetailModal";
import useEmployeeController from "../../controllers/employee-controller";
import {useAuth} from "../../context/authContext";
import CreateEmployeeModal from "../../components/modals/createEmployee-modal/CreateEmployeeModal";
import {EMPLOYEE_TYPES} from "../../enums/employeeTypes";
import AddActionButton from "../../components/action-buttons/addAction-button/AddActionButton";
import ScrollToTopButton from "../../components/main-buttons/scroll-button/ScrollToTopButton";

const AdministrationPage = () => {
  const employeeController = useEmployeeController()
  const {canManageContent} = useAuth()

  const headerActions = <>
    {canManageContent && <AddActionButton onClick={employeeController.toggleCreateModalOpen}/>}
  </>

  return <>
    <div className="page_title">
      <PageHeader
        title={
          <div className="page-header_title">
            <div className="page_name">Адміністрація</div>
          </div>
        }
        extra={headerActions}
        onBack={navigateBackHandler}
      />
    </div>
    <div className="page_content">
      <AdministrationList employeeController={employeeController}/>
      <EmployeeDetailModal employeeController={employeeController}/>
      {
        employeeController.isCreateModalOpen &&
          <CreateEmployeeModal employeeType={EMPLOYEE_TYPES.ADMINISTRATION} employeeController={employeeController}/>
      }

    </div>
    <ScrollToTopButton elementSelector={".page_content"}/>
  </>
}

export default AdministrationPage